import { useEffect } from "react";
import type { Movie } from "@/mocks/movies";

interface PlayModalProps {
  movie: Movie;
  episodeLabel: string;
  onClose: () => void;
}

export default function PlayModal({ movie, episodeLabel, onClose }: PlayModalProps) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950/70 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl overflow-hidden rounded-lg bg-background-50"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between border-b border-background-200 px-4 py-3">
          <div className="min-w-0">
            <h3 className="truncate font-heading text-sm font-semibold text-foreground-950">
              {movie.title} · {episodeLabel}
            </h3>
            <p className="text-xs text-foreground-500">演示播放窗口 · 非真实视频内容</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="关闭"
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-600 hover:bg-background-100 cursor-pointer"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="relative aspect-video w-full bg-foreground-950">
          <img
            src={movie.banner}
            alt={`${movie.title} 播放画面`}
            className="h-full w-full object-cover object-top opacity-40"
          />
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
            <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-500 text-background-50">
              <i className="ri-play-fill text-3xl" />
            </span>
            <p className="mt-4 font-heading text-base font-semibold text-background-50">
              正在播放：{episodeLabel}
            </p>
            <p className="mt-1 max-w-xs text-xs leading-relaxed text-background-200">
              这里仅为播放演示，不接入真实视频播放与下载功能。
            </p>
          </div>
        </div>

        <div className="flex flex-wrap items-center justify-between gap-3 px-4 py-3">
          <p className="text-xs text-foreground-500">
            提示：点击剧集列表可切换演示剧集。
          </p>
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
}